export default Object.freeze({
    DEBOUNCE: {
        DEFAULT: 400,
    },
})
